import React, { useEffect } from 'react';
import {   InfoBox,   ExerciseBox,   CodeBlock, CodeEditor, BoldTextParagraph,   InlineCode,   SectionTitle,  Note,  TableContainer,  Highlight,  PatternContainer,  SectionHeading,  SubHeading,  TwoColGrid,  ThreeColGrid,  GridItem,  Divider,  MutedText, Separator, CorrectionBox, Result} from '../../../../components/course/CourseComponents';

const Chapitre7Content = ({ courseId = 'baseprogrammation' }) => {
  
  // Effet pour donner le focus à l'éditeur quand le composant se monte
  useEffect(() => {
    // Le focus sera géré par la prop autoFocus du CodeEditor
  }, []);

  return (
    <>
     <InfoBox title="Objectif" color="blue">
        <p className="mb-0">
        Regrouper plusieurs informations dans une seule variable
        </p>
      </InfoBox>       

      <Separator type="text" text="Qu'est-ce qu'une structure ?" color="gray-darker" size="md" />
      <SectionTitle>Qu'est-ce qu'une structure ?</SectionTitle>
      <p>
        Une structure (ou objet) permet de stocker plusieurs valeurs liées ensemble. 
        C'est très utile pour :
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>créer des personnages de jeu</li>
        <li>gérer des objets complexes</li>
        <li>organiser des données</li>
      </ul>

      <p>Par exemple : un joueur avec un nom, un âge et un score.</p>

      <Separator type="text" text="Créer une structure" color="gray-darker" size="md" />
      <SectionTitle>Créer une structure</SectionTitle>

      <Note type="gray" title="Initialisation d'une structure">
        <CodeBlock language="javascript">
{`let joueur = {
  nom: "Michael",
  age: 40,
  score: 250
};`}
        </CodeBlock>
        <p  >👉 Ici, la structure <InlineCode>joueur</InlineCode> contient 3 propriétés.</p>
      </Note>

      <p>Tu peux accéder aux données comme ceci :</p>

      <Note type="gray" title="🔍 Accéder aux propriétés :">
        <CodeBlock language="javascript">
{`print(joueur.nom);    // "Michael"
print(joueur.score);  // 250`}
        </CodeBlock>
      </Note>

      <Separator type="text" text="Manipuler les propriétés" color="gray-darker" size="md" />
      <SectionTitle>Manipuler les propriétés</SectionTitle>

      <Note type="gray" title="✏️ Modification d'une propriété :">
        <CodeBlock language="javascript">
{`joueur.score += 50;  // ajoute 50 au score
joueur.nom = "Alex";  // change le nom`}
        </CodeBlock>
      </Note>

      <Note type="gray" title="➕ Ajouter de nouvelles propriétés :">
        <CodeBlock language="javascript">
{`joueur.niveau = 5;     // ajoute une propriété niveau
joueur.vies = 3;       // ajoute une propriété vies`}
        </CodeBlock>
      </Note>

      <Separator type="text" text="Exercices pratiques" color="gray-darker" size="md" />
      <SectionTitle>Exercices pratiques</SectionTitle>

      <Note type="exercice" title="🧪 Exercice structure  :">
        Crée une structure <InlineCode>monstre</InlineCode> avec les propriétés nom, pv, attaque. Affiche ses infos dans la console :<br/>
        - Crée une structure <InlineCode>monstre</InlineCode> avec 3 propriétés<br/>
        - Affiche le nom avec <InlineCode>print()</InlineCode><br/>
        - Affiche les PV et l'attaque avec des messages<br/>
        <Result>Dragon | PV : 100 | Attaque : 15</Result>
        
        <CorrectionBox>
          <CodeBlock language="javascript">
{`let monstre = {
  nom: "Dragon",
  pv: 100,
  attaque: 15
};

print(monstre.nom);
print("PV : " + monstre.pv);
print("Attaque : " + monstre.attaque);`}
          </CodeBlock>
        </CorrectionBox>
      </Note>

      <CodeEditor
        courseId={courseId}
        editorId="structure-base"
        title="Exercice : Créer une structure"
        showConsole={true}
        height="250px"
        initialCode=""
        autoFocus={true}
      />

     

      <p>
        ✅ Bravo ! Tu sais maintenant structurer des données complexes, comme les personnages d'un jeu 🎮
      </p>
      
      <BoldTextParagraph>
        Prochaine étape : les fonctions ⚙️
      </BoldTextParagraph>

  </>
  );
};

export default Chapitre7Content; 